var React = require('react');

function XInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M21.884.756L11.83 11.376l8.589 7.857L19.5 20l-8.482-7.762-9.134 9.518L1 21l9.154-9.539-9.499-8.99.845-.834 9.466 8.962L21 0l.884.756z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M20.5 20a.5.5 0 100 1 .5.5 0 000-1zm-1.5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z","key":1}),React.createElement("circle",{"fill":"currentColor","cx":"1","cy":"2","r":"1","key":2})]);
}

XInline.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = XInline;

XInline.default = XInline;
